module.exports = __webpack_public_path__ + "static/img/instant3.a76fa79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/instant3.png
// module id = YN0a
// module chunks = 1